import { Default } from './variants/Default.js';
import { Custom } from './variants/Custom.js';
import '../../extends-30811c5e.js';
import '../../objectWithoutProperties-dd908bcc.js';
import 'react';
import 'classnames';
import '../../utils/getPrefix.js';
import './ModalBase.js';
import '../../defineProperty-6f298737.js';
import 'react-dom';
import '../Icon/IconCrossSmall.js';

var Modal = {
  Default: Default,
  Custom: Custom
};

export { Modal };
